export default "__VITE_ASSET__Cd9wcfY5__"